{
  "INBOX_MGMT": {
    "HEADER": "قنوات التواصل",
    "DESCRIPTION": "القناة هي وضع الاتصال الذي يختاره العميل للتفاعل معك. صندوق الوارد هو المكان الذي تدير فيه التفاعلات لقناة معينة. ويمكن أن تشمل الاتصالات من مصادر مختلفة مثل البريد الإلكتروني، والمحادثة الحية، ووسائط الإعلام الاجتماعية.",
    "LEARN_MORE": "تعلم المزيد عن صناديق البريد",
    "RECONNECT": {
      "BUTTON": "إعادة الاتصال",
      "FACEBOOK": "انتهت صلاحية الاتصال بـ Facebook أو تم إلغاؤه. لا تصل الرسائل المرسلة إلى الصفحة إلى صندوق الوارد هذا، وقد تفشل الردود. يجب على شخص يدير صفحة Facebook النقر على إعادة الاتصال وتسجيل الدخول إلى Facebook.",
      "INSTAGRAM": "انتهت صلاحية الاتصال بـ Instagram أو تم إلغاؤه. لا تصل الرسائل المرسلة إلى الحساب إلى صندوق الوارد هذا، وقد تفشل الردود. انقر على إعادة الاتصال وسجّل الدخول إلى حساب Instagram نفسه. يؤدي استخدام حساب آخر إلى إنشاء صندوق وارد جديد.",
      "GOOGLE": "انتهت صلاحية الاتصال بـ Google أو تم إلغاؤه. لا تصل رسائل البريد الإلكتروني الجديدة إلى صندوق الوارد هذا، وقد تفشل الردود. انقر على إعادة الاتصال وسجّل الدخول إلى Google باستخدام {email}.",
      "MICROSOFT": "انتهت صلاحية الاتصال بـ Microsoft أو تم إلغاؤه. لا تصل رسائل البريد الإلكتروني الجديدة إلى صندوق الوارد هذا، وقد تفشل الردود. انقر على إعادة الاتصال وسجّل الدخول إلى Microsoft باستخدام {email}.",
      "ALLEGRO": "انتهت صلاحية الاتصال بـ Allegro أو تم إلغاؤه. لا تصل رسائل المشترين إلى صندوق الوارد هذا، وقد تفشل الردود. انقر على إعادة الاتصال وسجّل الدخول إلى Allegro بصفتك البائع {seller}. يؤدي استخدام حساب بائع آخر إلى إنشاء صندوق وارد جديد.",
      "IMAP_LOGIN": "يرفض خادم البريد تسجيل الدخول إلى IMAP باسم {login}. لا تصل الرسائل الجديدة إلى هذا الصندوق. تحققوا من اسم الدخول وكلمة المرور الخاصة بـ IMAP في تبويب {tab} ثم احفظوها. نواصل محاولة تسجيل الدخول، وسيتعافى الصندوق فور نجاح الدخول.",
      "WHATSAPP": "انتهت صلاحية الاتصال بواتساب أو تم إلغاؤه. لا تصل المرفقات من العملاء إلى صندوق الوارد هذا، وقد تفشل الردود. انقر على إعادة الاتصال، وسجّل الدخول إلى فيسبوك، واختر الرقم {phone} مرة أخرى."
    },
    "LIST": {
      "404": "لا توجد صناديق وارد لقنوات تواصل مرتبطة بهذا الحساب.",
      "RECONNECT_REQUIRED": "يلزم إعادة الاتصال"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "اختر قناة",
        "BODY": "اختر الخدمة التي تود ربطها بالدردشة."
      },
      "INBOX": {
        "TITLE": "إنشاء قناة تواصل",
        "BODY": "قم بالمصادقة على حسابك وإنشاء قناة التواصل."
      },
      "AGENT": {
        "TITLE": "إضافة وكلاء",
        "BODY": "إضافة وكلاء إلى صندوق الوارد الخاص بقناة التواصل التي تم إنشاؤها."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "أصبح كل شيء جاهزاً الآن!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "اسم صندوق الوارد لقناة التواصل",
        "PLACEHOLDER": "أدخل اسم صندوق الوارد الخاص بك (مثال: Acme Inc)",
        "ERROR": "الرجاء إدخال اسم صندوق الوارد صالح"
      },
      "WEBSITE_NAME": {
        "LABEL": "اسم الموقع",
        "PLACEHOLDER": "أدخل اسم موقع الويب الخاص بك (مثال: Acme Inc)"
      },
      "INTERNAL_NAME": {
        "LABEL": "الاسم الداخلي",
        "PLACEHOLDER": "سمِّ صندوق الوارد كما سيظهر في لوحة التحكم هذه",
        "ERROR": "الرجاء إدخال اسم داخلي فريد"
      },
      "FB": {
        "HELP": "ملحوظة: بالمصادقة على حسابك، فنحن يمكننا فقط الوصول إلى الرسائل الواردة لصفحتك. لا يمكننا أبداً بأي شكل من الأشكال الوصول إلى رسائلك الخاصة في حسابك الشخصي.",
        "CHOOSE_PAGE": "اختر صفحة",
        "CHOOSE_PLACEHOLDER": "اختر صفحة من القائمة",
        "INBOX_NAME": "اسم صندوق الوارد لقناة التواصل",
        "ADD_NAME": "قم بتعيين اسم لصندوق الوارد الخاص بقناتك الجديدة",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "اختر قيمة",
        "CREATE_INBOX": "إنشاء صندوق وارد"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "المتابعة عبر Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "ربط حساب Instagram الخاص بك",
        "HELP": "لإضافة حساب Instagram الخاص بك كقناة، عليك التحقق من حسابك عبر النقر على 'المتابعة عبر Instagram' ",
        "ERROR_MESSAGE": "حدث خطأ أثناء الاتصال بـ Instagram، يرجى المحاولة مرة أخرى",
        "ERROR_AUTH": "حدث خطأ أثناء الاتصال بـ Instagram، يرجى المحاولة مرة أخرى",
        "NEW_INBOX_SUGGESTION": "كان حساب Instagram هذا مرتبطاً سابقاً بصندوق وارد مختلف وقد تم ترحيله إلى هنا الآن. ستظهر جميع الرسائل الجديدة هنا. لن يتمكن صندوق الوارد القديم من إرسال أو استقبال رسائل لهذا الحساب بعد الآن.",
        "DUPLICATE_INBOX_BANNER": "تم ترحيل حساب Instagram هذا إلى صندوق وارد قناة Instagram الجديدة. لن تتمكن من إرسال أو استقبال رسائل Instagram من صندوق الوارد هذا بعد الآن."
      },
      "TWITTER": {
        "HELP": "لإضافة حساب تويتر الخاص بك كقناة تواصل، تحتاج إلى مصادقة حسابك على تويتر بك بالنقر على زر \"تسجيل الدخول باستخدام تويتر\" ",
        "ERROR_MESSAGE": "حدث خطأ أثناء الاتصال بـ Twitter، الرجاء المحاولة مرة أخرى",
        "TWEETS": {
          "ENABLE": "إنشاء محادثات من التغريدات المشار إليها"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "قناة الموقع",
        "DESC": "قم بإنشاء قناة تواصل لموقع الويب الخاص بك وابدأ في استقبال الرسائل من عملائك عبر صندوق الدردشة المباشرة.",
        "LOADING_MESSAGE": "جاري إنشاء قناة تواصل للموقع",
        "CHANNEL_AVATAR": {
          "LABEL": "الصورة الرمزية للقناة"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "رابط Webhook",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "الرجاء إدخال عنوان URL صالح"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "نطاق الموقع",
          "PLACEHOLDER": "أدخل نطاق موقعك الإلكتروني (مثال: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "العنوان الترحيبي",
          "PLACEHOLDER": "مرحبا بك!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "افتتاحية الترحيب",
          "PLACEHOLDER": "نحن نجعل من السهل عليك التواصل معنا. اسألنا أي شيء، أو قم بمشاركتنا ملاحظاتك."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "رسالة الترحيب التلقائية",
          "PLACEHOLDER": "يتم الرد عادة خلال بضع ساعات."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "تفعيل رسالة الترحيب التلقائية",
          "HELP_TEXT": "إرسال رسالة تحية تلقائياً عند إنشاء محادثة جديدة.",
          "ENABLED": "مفعل",
          "DISABLED": "معطّل"
        },
        "REPLY_TIME": {
          "TITLE": "حدد وقت الرد",
          "IN_A_FEW_MINUTES": "في غضون دقائق قليلة",
          "IN_A_FEW_HOURS": "في غضون ساعات قليلة",
          "IN_A_DAY": "خلال يوم",
          "HELP_TEXT": "وقت الرد هذا سيتم عرضه على أداة الدردشة المباشرة"
        },
        "WIDGET_COLOR": {
          "LABEL": "لون صندوق الدردشة",
          "PLACEHOLDER": "تحديث اللون الرئيسي لصندوق الدردشة"
        },
        "SUBMIT_BUTTON": "إنشاء قناة تواصل",
        "API": {
          "ERROR_MESSAGE": "لم نتمكن من إنشاء قناة موقع، الرجاء المحاولة مرة أخرى"
        }
      },
      "TWILIO": {
        "TITLE": "قناة Twilio SMS/WhatsApp",
        "DESC": "قم بإضافة قناة Twilio لتمكن عملائك من التواصل معك عبر الرسائل القصيرة SMS أو عبر واتساب.",
        "ACCOUNT_SID": {
          "LABEL": "معرف حساب Twilio (يعرف أيضاً بـ Account SID)",
          "PLACEHOLDER": "الرجاء إدخال معرف حساب Twilio الخاص بك (يعرف أيضاً بـ Account SID)",
          "ERROR": "هذا الحقل مطلوب"
        },
        "API_KEY": {
          "USE_API_KEY": "استخدم مفتاح مصادقة API",
          "LABEL": "مفتاح API SID",
          "PLACEHOLDER": "الرجاء إدخال معرف مفتاح واجهة برمجة التطبيقات API الخاص بك",
          "ERROR": "هذا الحقل مطلوب"
        },
        "API_KEY_SECRET": {
          "LABEL": "مفتاح سر API",
          "PLACEHOLDER": "الرجاء إدخال سر مفتاح API الخاص بك",
          "ERROR": "هذا الحقل مطلوب"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "SID خدمة المراسلة",
          "PLACEHOLDER": "الرجاء إدخال SID لخدمة مراسلة Twilio",
          "ERROR": "هذا الحقل مطلوب",
          "USE_MESSAGING_SERVICE": "استخدام خدمة مراسلة توليو"
        },
        "CHANNEL_TYPE": {
          "LABEL": "نوع القناة",
          "ERROR": "الرجاء تحديد نوع القناة"
        },
        "AUTH_TOKEN": {
          "LABEL": "رمز المصادقة Auth Token",
          "PLACEHOLDER": "الرجاء إدخال رمز مصادقة Twilio الخاص بك Auth Token",
          "ERROR": "هذا الحقل مطلوب"
        },
        "CHANNEL_NAME": {
          "LABEL": "اسم صندوق الوارد لقناة التواصل",
          "PLACEHOLDER": "الرجاء إدخال اسم القناة",
          "ERROR": "هذا الحقل مطلوب"
        },
        "PHONE_NUMBER": {
          "LABEL": "رقم الهاتف",
          "PLACEHOLDER": "الرجاء إدخال رقم الهاتف الذي سيتم إرسال الرسائل منه.",
          "ERROR": "الرجاء تقديم رقم هاتف صالح يبدأ بإشارة '+' ولا يحتوي على أي مسافات."
        },
        "API_CALLBACK": {
          "TITLE": "عنوان Callback URL",
          "SUBTITLE": "يتوجب تهيئة عنوان callback URL في إعدادات Twilio بإدخال القيمة أدناه."
        },
        "SUBMIT_BUTTON": "إنشاء قناة Twilio",
        "API": {
          "ERROR_MESSAGE": "تعذر تكوين المصادقة بواسطة بيانات الاعتماد الخاصة بحسابك على Twilio، يرجى المحاولة مرة أخرى"
        }
      },
      "SMS": {
        "TITLE": "قناة SMS",
        "DESC": "ابدأ في دعم عملائك عبر الرسائل القصيرة.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "TWILIO": "تويليو",
          "BANDWIDTH": "سعة الإنترنت",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "لم نتمكن من حفظ قناة الرسائل القصيرة"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "معرف الحساب",
            "PLACEHOLDER": "الرجاء إدخال معرف حساب النطاق الترددي الخاص بك",
            "ERROR": "هذا الحقل مطلوب"
          },
          "API_KEY": {
            "LABEL": "مفتاح API",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "هذا الحقل مطلوب"
          },
          "API_SECRET": {
            "LABEL": "سرية API",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "هذا الحقل مطلوب"
          },
          "APPLICATION_ID": {
            "LABEL": "معرف التطبيق",
            "PLACEHOLDER": "الرجاء إدخال معرف تطبيق النطاق الترددي الخاص بك",
            "ERROR": "هذا الحقل مطلوب"
          },
          "INBOX_NAME": {
            "LABEL": "اسم صندوق الوارد لقناة التواصل",
            "PLACEHOLDER": "الرجاء إدخال اسم القناة",
            "ERROR": "هذا الحقل مطلوب"
          },
          "PHONE_NUMBER": {
            "LABEL": "رقم الهاتف",
            "PLACEHOLDER": "الرجاء إدخال رقم الهاتف الذي سيتم إرسال الرسائل منه.",
            "ERROR": "الرجاء تقديم رقم هاتف صالح يبدأ بإشارة '+' ولا يحتوي على أي مسافات."
          },
          "SUBMIT_BUTTON": "إنشاء قناة عرض التردد",
          "API": {
            "ERROR_MESSAGE": "تعذر تكوين المصادقة بواسطة بيانات الاعتماد الخاصة بحسابك على Twilio، يرجى المحاولة مرة أخرى"
          },
          "API_CALLBACK": {
            "TITLE": "عنوان Callback URL",
            "SUBTITLE": "يتوجب تهيئة عنوان callback URL في إعدادات Twilio بإدخال القيمة أدناه."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "اسم صندوق الوارد",
            "PLACEHOLDER": "الرجاء إدخال اسم صندوق الوارد",
            "ERROR": "هذا الحقل مطلوب"
          },
          "PHONE_NUMBER": {
            "LABEL": "رقم الهاتف",
            "PLACEHOLDER": "الرجاء إدخال رقم الهاتف الذي سيتم إرسال الرسائل منه.",
            "ERROR": "الرجاء تقديم رقم هاتف صالح يبدأ بإشارة `+`."
          },
          "SUBMIT_BUTTON": "إنشاء قناة SMS Brana",
          "API": {
            "ERROR_MESSAGE": "لم نتمكن من إنشاء قناة SMS Brana"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "اسم صندوق الوارد",
            "PLACEHOLDER": "الرجاء إدخال اسم صندوق الوارد",
            "ERROR": "هذا الحقل مطلوب"
          },
          "PHONE_NUMBER": {
            "LABEL": "رقم الهاتف",
            "PLACEHOLDER": "الرجاء إدخال رقم الهاتف الذي سيتم إرسال الرسائل منه.",
            "ERROR": "الرجاء تقديم رقم هاتف صالح يبدأ بإشارة `+`."
          },
          "SUBMIT_BUTTON": "إنشاء قناة DIDWW",
          "API": {
            "ERROR_MESSAGE": "لم نتمكن من إنشاء قناة DIDWW"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API Provider",
          "WHATSAPP_CLOUD": "واتساب السحابة"
        },
        "API_CALLBACK": {
          "SUBTITLE": "يجب عليك تكوين رابط الويب هوك و رمز التحقق في بوابة مطور الفيسبوك مع القيم الموضحة أدناه.",
          "WEBHOOK_URL": "رابط Webhook",
          "WEBHOOK_VERIFICATION_TOKEN": "رمز التحقق من Webhook"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "إعداد سريع عبر Meta",
          "DESC": "سيتم تحويلك إلى Meta لتسجيل الدخول إلى حساب WhatsApp Business الخاص بك. يساعد امتلاك صلاحية وصول المسؤول على جعل الإعداد سلساً وسهلاً.",
          "BENEFITS": {
            "EASY_SETUP": "لا حاجة إلى إعداد يدوي",
            "SECURE_AUTH": "مصادقة آمنة قائمة على OAuth",
            "AUTO_CONFIG": "تهيئة تلقائية للـ Webhook ورقم الهاتف"
          },
          "SUBMIT_BUTTON": "الاتصال عبر WhatsApp Business",
          "AUTH_PROCESSING": "جارٍ المصادقة عبر Meta",
          "WAITING_FOR_BUSINESS_INFO": "يرجى إكمال إعداد النشاط التجاري في نافذة Meta...",
          "PROCESSING": "جارٍ إعداد حساب WhatsApp Business الخاص بك",
          "CANCELLED": "تم إلغاء التسجيل في WhatsApp",
          "WAITING_FOR_AUTH": "بانتظار المصادقة...",
          "INVALID_BUSINESS_DATA": "تم استلام بيانات نشاط تجاري غير صالحة من Facebook. يرجى المحاولة مرة أخرى.",
          "SIGNUP_ERROR": "حدث خطأ أثناء التسجيل",
          "SDK_LOAD_ERROR": "تعذّر تحميل Facebook SDK. يُرجى المحاولة مرة أخرى.",
          "AUTH_NOT_COMPLETED": "لم تكتمل المصادقة. يرجى إعادة بدء العملية.",
          "SUCCESS_FALLBACK": "تم تهيئة حساب WhatsApp Business بنجاح",
          "RECONNECTED": "تمت إعادة ربط قناة واتساب بنجاح"
        },
        "API": {
          "ERROR_MESSAGE": "لم نتمكن من حفظ قناة واتساب"
        }
      },
      "API_CHANNEL": {
        "TITLE": "قناة API",
        "DESC": "اربط مع قناة API وابدأ في دعم عملائك.",
        "CHANNEL_NAME": {
          "LABEL": "اسم القناة",
          "PLACEHOLDER": "الرجاء إدخال اسم القناة",
          "ERROR": "هذا الحقل مطلوب"
        },
        "WEBHOOK_URL": {
          "LABEL": "رابط Webhook",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "رابط Webhook"
        },
        "SUBMIT_BUTTON": "إنشاء قناة API",
        "API": {
          "ERROR_MESSAGE": "لم نتمكن من حفظ قناة الـ api"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "قناة Salesforce",
        "DESC": "تكامل مع قناة Salesforce وابدأ في دعم عملائك.",
        "CHANNEL_NAME": {
          "LABEL": "اسم القناة",
          "PLACEHOLDER": "الرجاء إدخال اسم القناة",
          "ERROR": "هذا الحقل مطلوب"
        },
        "API_BASE_URL": {
          "LABEL": "رابط API الخاص بـ Salesforce",
          "SUBTITLE": "قم بتهيئة الرابط الأساسي لمثيل Salesforce الخاص بك.",
          "PLACEHOLDER": "رابط API الخاص بـ Salesforce"
        },
        "KEY_ID": {
          "LABEL": "معرف المفتاح",
          "SUBTITLE": "معرف المفتاح الخاص بقناة Salesforce.",
          "PLACEHOLDER": "معرف المفتاح"
        },
        "SECRET": {
          "LABEL": "السر",
          "SUBTITLE": "السر الخاص بقناة Salesforce.",
          "PLACEHOLDER": "*****"
        },
        "SUBMIT_BUTTON": "إنشاء قناة Salesforce",
        "API": {
          "ERROR_MESSAGE": "لم نتمكن من حفظ قناة Salesforce"
        },
        "API_CALLBACK": {
          "TITLE": "رابط Webhook",
          "SUBTITLE": "يتوجب عليك تهيئة رابط الـ Webhook في Salesforce بالرابط المذكور هنا."
        },
        "BEARER_TOKEN": {
          "TITLE": "رمز Bearer",
          "SUBTITLE": "استخدم رمز Bearer هذا للمصادقة عند تهيئة الـ Webhook في Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "تجاوز مرسل البريد الإلكتروني",
          "SUBTITLE": "في حال تعيينه، سيُستخدم عنوان البريد الإلكتروني هذا كمرسل لجميع رسائل البريد الصادرة بدلاً من البريد الإلكتروني المصدر للمحادثة.",
          "PLACEHOLDER": "مثال: support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "قناة Allegro",
        "DESC": "اربط حساب بائع على Allegro وأجب عن رسائل مركز الرسائل الخاص به من مركز الاتصال.",
        "CHANNEL_NAME": {
          "LABEL": "اسم صندوق الوارد",
          "SUBTITLE": "الاسم الذي يراه الوكلاء لصندوق الوارد هذا.",
          "PLACEHOLDER": "أدخل اسم صندوق الوارد",
          "ERROR": "هذا الحقل مطلوب"
        },
        "SUBMIT_BUTTON": "تسجيل الدخول باستخدام Allegro",
        "API": {
          "ERROR_MESSAGE": "حدث خطأ أثناء الاتصال بـ Allegro، الرجاء المحاولة مرة أخرى"
        },
        "SELLER_LOGIN": {
          "TITLE": "تسجيل الدخول إلى Allegro",
          "SUBTITLE": "حساب البائع الذي يقرأ صندوق الوارد هذا رسائله ويجيب عنها."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "قناة Kaufland",
        "DESC": "أجب عن رسائل التذاكر التي يرسلها إليك المشترون على سوق Kaufland.",
        "CHANNEL_NAME": {
          "LABEL": "اسم القناة",
          "PLACEHOLDER": "الرجاء إدخال اسم القناة",
          "ERROR": "هذا الحقل مطلوب"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "مفتاح Client Key المكوّن من 32 حرفًا من صفحة إعدادات API في حساب البائع على Kaufland.",
          "PLACEHOLDER": "مفتاح من 32 حرفًا",
          "ERROR": "أدخل مفتاح Client Key المكوّن من 32 حرفًا"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "مفتاح Secret Key المكوّن من 64 حرفًا والتابع لمفتاح Client Key. يعرضه Kaufland مرة واحدة، ولا يُرسل إلى هذه الصفحة مرة أخرى.",
          "PLACEHOLDER": "مفتاح من 64 حرفًا",
          "ERROR": "أدخل مفتاح Secret Key المكوّن من 64 حرفًا"
        },
        "SUBMIT_BUTTON": "إنشاء قناة Kaufland",
        "API": {
          "ERROR_MESSAGE": "لم نستطع حفظ قناة Kaufland"
        },
        "DISCONNECTED": {
          "TITLE": "انقطع الاتصال",
          "MESSAGE": "رفض Kaufland مفاتيح API هذه. أدخل Client Key و Secret Key مرة أخرى لإعادة ربط صندوق الوارد هذا."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "قناة البريد الالكتروني",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "اسم القناة",
          "PLACEHOLDER": "الرجاء إدخال اسم القناة",
          "ERROR": "هذا الحقل مطلوب"
        },
        "EMAIL": {
          "LABEL": "البريد الإلكتروني",
          "SUBTITLE": "البريد الإلكتروني حيث يرسل عملاؤك تذاكر الدعم",
          "PLACEHOLDER": "البريد الإلكتروني"
        },
        "SUBMIT_BUTTON": "إنشاء قناة البريد الإلكتروني",
        "API": {
          "ERROR_MESSAGE": "لم نتمكن من حفظ قناة البريد الإلكتروني"
        },
        "FINISH_MESSAGE": "بدء إعادة توجيه رسائل البريد الإلكتروني الخاصة بك إلى عنوان البريد الإلكتروني التالي."
      },
      "LINE_CHANNEL": {
        "TITLE": "قناة LINE",
        "DESC": "التكامل مع قناة LINE وبدء دعم عملائك.",
        "CHANNEL_NAME": {
          "LABEL": "اسم القناة",
          "PLACEHOLDER": "الرجاء إدخال اسم القناة",
          "ERROR": "هذا الحقل مطلوب"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "معرف قناة LINE",
          "PLACEHOLDER": "معرف قناة LINE"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "سرية قناة LINE",
          "PLACEHOLDER": "سرية قناة LINE"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "رمز قناة LINE",
          "PLACEHOLDER": "رمز قناة LINE"
        },
        "SUBMIT_BUTTON": "إنشاء قناة LINE",
        "API": {
          "ERROR_MESSAGE": "لم نستطع حفظ قناة LINE"
        },
        "API_CALLBACK": {
          "TITLE": "عنوان Callback URL",
          "SUBTITLE": "يجب عليك تكوين URL ويب هوك في تطبيق LINE مع عنوان URL المذكور هنا."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "قناة تيليجرام",
        "DESC": "التكامل مع قناة تيليجرام والبدء في دعم عملائك.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "تكوين رمز البوت الذي حصلت عليه من Telegram BotFather.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "إنشاء قناة تيليجرام",
        "API": {
          "ERROR_MESSAGE": "لم نتمكن من حفظ قناة التلجرام"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "المكالمات الهاتفية",
        "DESC": "قم بإعداد المكالمات الهاتفية التي ستظهر ضمن صندوق الوارد هذا.",
        "NAME": {
          "LABEL": "اسم صندوق الوارد",
          "SUBTITLE": "اختر اسماً يسهل التعرف عليه."
        },
        "PHONE_NUMBER": {
          "LABEL": "رقم الهاتف",
          "SUBTITLE": "أدخل أرقام الهاتف التابعة لصندوق الوارد هذا، ويمكنك إضافة أرقام أخرى لاحقاً.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "إنشاء صندوق وارد للمكالمات الهاتفية",
        "API": {
          "ERROR_MESSAGE": "لم نتمكن من إنشاء صندوق الوارد"
        }
      },
      "AUTH": {
        "TITLE": "اختر قناة",
        "DESC": "يدعم أدوات الدردشة الحية، والميسنجر الفيسبوك، وملفات التويتر الشخصية، و WhatsApp، ورسائل البريد الإلكتروني، إلخ، كقنوات. إذا كنت ترغب في إنشاء قناة مخصصة، يمكنك إنشاءها باستخدام قناة API. للبدء، اختر إحدى القنوات أدناه."
      },
      "AGENTS": {
        "TITLE": "وكيل الدعم",
        "DESC": "هنا يمكنك إضافة موظفين لإدارة صندوق الوارد الخاص بقناة تواصلك التي تم إنشاؤها حديثاً. الموظفين الذين يتم تحديدهم هنا هم فقط من يمكنهم الوصول إلى صندوق الوارد الخاص بتلك القناة. الموظفين الذين ليسوا جزءاً من صندوق الوارد هذا لن يكونوا قادرين على رؤية أو الرد على الرسائل في قناة التواصل هذه عند تسجيل الدخول. <br> <b>ملحوظة:</b> كمسؤول، إذا كنت بحاجة إلى الوصول إلى جميع صناديق الوارد، يجب عليك إضافة نفسك كموظف لجميع صناديق الوارد الخاصة بقنوات التواصل التي تنشئها.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "اختر وكلاء لصندوق الوارد"
      },
      "DETAILS": {
        "TITLE": "تفاصيل قناة التواصل",
        "DESC": "من القائمة المنسدلة أدناه، حدد صفحة فيس بوك التي تريد ربطها بالدردشة. يمكنك أيضًا تخصيص اسم لصندوق الوارد الخاص بهذه الصفحة للحصول على تجربة وصول أفضل."
      },
      "FINISH": {
        "TITLE": "تم!",
        "DESC": "لقد تم بنجاح ربط صفحة فيسبوك الخاصة بك مع الدردشة. في المرة القادمة التي يرسل فيها العملاء رسالة إلى صفحتك، ستظهر المحادثة تلقائيًا على صندوق الوارد الخاص بك هنا.<br>نحن نزودك أيضًا بالكود النصي لصندوق دردشة الماسنجر والذي يمكنك إضافته بسهولة إلى الموقع الخاص بك لاستقبال الرسائل من الزوار كذلك. بمجرد أن يتم ذلك على موقع الويب الخاص بك، يمكن للعملاء مراسلتك من موقع الويب الخاص بك بدون الحاجة لأي أدوات خارجية وستظهر المحادثة هنا في الدردشة.<br>رائع، أليس كذلك؟ نحن بالتأكيد نحاول أن نكون الأفضل :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "حدد مزود البريد الإلكتروني الخاص بك",
        "DESCRIPTION": "Select an email provider from the list below. If you don't see your email provider in the list, you can select the other provider option and provide the IMAP and SMTP Credentials."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Click on the Sign in with Microsoft button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "تسجيل الدخول باستخدام Microsoft",
        "ERROR_MESSAGE": "There was an error connecting to Microsoft, please try again"
      },
      "GOOGLE": {
        "TITLE": "البريد الإلكتروني لجوجل",
        "DESCRIPTION": "انقر على تسجيل الدخول باستخدام زر جوجل للبدء. سيتم إعادة توجيهك إلى صفحة تسجيل الدخول بالبريد الإلكتروني. بمجرد قبول الأذونات المطلوبة، سيتم إعادة توجيهك إلى خطوة إنشاء علبة الوارد.",
        "SIGN_IN": "تسجيل الدخول باستخدام Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "حدث خطأ أثناء الاتصال بجوجل، الرجاء المحاولة مرة أخرى"
      }
    },
    "DETAILS": {
      "LOADING_FB": "جار المصادقة والربط مع الفيسبوك...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "حدث خطأ ما، الرجاء تحديث الصفحة...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "ERROR_CHANNEL_CREATION": "لم نتمكن من إنشاء صندوق الوارد، الرجاء المحاولة مرة أخرى",
      "CREATING_CHANNEL": "جار إنشاء قناة التواصل...",
      "TITLE": "تهيئة إعدادات قناة التواصل",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "إضافة وكلاء",
      "ADD_AGENTS": "إضافة وكلاء إلى صندوق الوارد الخاص بالقناة..."
    },
    "FINISH": {
      "TITLE": "أصبحت قناة التواصل جاهزة الآن!",
      "MESSAGE": "يمكنك الآن التواصل مع عملائك من خلال قناتك الجديدة",
      "BUTTON_TEXT": "خذني إلى هناك",
      "MORE_SETTINGS": "المزيد من الإعدادات",
      "WEBSITE_SUCCESS": "لقد انتهيت بنجاح من إنشاء قناة دردشة مباشرة لموقعك. انسخ الرمز الموضح أدناه وقم بإضافته إلى موقع الويب الخاص بك. في المرة القادمة التي يستخدم فيها العميل الدردشة المباشرة، ستظهر المحادثة تلقائياً على صندوق الوارد الخاص بك."
    },
    "REAUTH": "إعادة التصريح",
    "VIEW": "عرض",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "تم تحديث إعدادات قناة التواصل بنجاح",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "تم تحديث إعدادات الإسناد التلقائي بنجاح",
        "ERROR_MESSAGE": "تعذر تحديث إعدادات صندوق الوارد. الرجاء المحاولة مرة أخرى لاحقاً."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "مفعل",
        "DISABLED": "معطّل"
      },
      "ENABLE_CSAT": {
        "ENABLED": "مفعل",
        "DISABLED": "معطّل"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "مفعّل",
        "DISABLED": "معطّل"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "حدد الاسم الذي يظهر للعميل الخاص بك عندما يتلقى رسائل البريد الإلكتروني من الوكلاء الخاصين.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Friendly",
          "FROM": "من",
          "SUBTITLE": "يضاف اسم الوكيل الذي أرسل الرد باسم المرسل لجعله صديقا."
        },
        "PROFESSIONAL": {
          "TITLE": "Professional",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "حفظ"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "مفعل",
        "DISABLED": "معطّل"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "مفعل",
        "DISABLED": "معطّل"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "بدون"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "مفعل",
        "DISABLED": "معطّل"
      },
      "ENABLE_HMAC": {
        "LABEL": "تفعيل"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "مفعل",
        "DISABLED": "معطّل"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "مفعل",
        "DISABLED": "معطّل"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "تفعيل مزامنة رسائل البريد الإلكتروني الواردة"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "تفعيل نطاق بريد إلكتروني مخصص (خدمة مدفوعة)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "تفعيل معالجة تعليقات Facebook"
      },
      "SIGNATURE": {
        "TITLE": "توقيع HTML",
        "SUB_TEXT": "سيُضاف هذا التوقيع إلى تذييل كل رسالة تُرسل من صندوق الوارد هذا.",
        "HTML_CONTENT": "كود HTML",
        "HTML_CONTENT_HELP": "سيتم استبدال {'{{'}name{'}}'} باسم الوكيل.\n{'{{'}email{'}}'} سيُستبدل بعنوان البريد الإلكتروني للوكيل الذي أرسل البريد.\n{'{{'}position{'}}'} سيُستبدل بمنصب الوكيل.\n{'{{'}custom_line{'}}'} سيُستبدل بالسطر المخصص للوكيل.\n{'{{'}email_signature_picture{'}}'} سيُستبدل برابط صورة توقيع البريد الإلكتروني للوكيل (وليس وسم صورة) — استخدمه كمصدر للصورة (خاصية src في وسم img).",
        "PREVIEW": "معاينة"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "التوقيعات حسب البلد",
        "SUB_TEXT": "يحصل الرد على توقيع بلد المشتري.",
        "HELP": "يُوقَّع الرد وفق بلد المحادثة: متجر Kaufland، أو سوق طلب Allegro، وإلا فبحسب اللغة التي يكتب بها المشتري. عندما يكون البلد غير معروف أو لا يوجد له توقيع هنا، يُستخدم توقيع HTML أعلاه. تمنع الأسواق الإلكترونية الروابط إلى موقعك وبيانات الاتصال، لذا اكتفِ بتحية و{'{{'}name{'}}'}.",
        "EMPTY": "ليس لديك توقيعات للبلدان بعد، لذا تستخدم الردود توقيع HTML أعلاه.",
        "COUNTRY": "اختر بلداً",
        "ADD": "إضافة توقيع لبلد",
        "REMOVE": "إزالة"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "بادئة اتصال رقم الهاتف",
        "PLACEHOLDER": "أدخل البادئة لتوجيه المكالمات بشكل صحيح (مثال: *99)",
        "HELP_TEXT": "ستُضاف هذه البادئة تلقائياً قبل أرقام هواتف جهات الاتصال عند الاتصال من صندوق الوارد هذا."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "نص زر \"سنحلها لاحقًا\"",
        "PLACEHOLDER": "مثال: سنحل هذا الموضوع عبر البريد الإلكتروني. أريد أن أسأل عن شيء آخر الآن.",
        "HELP_TEXT": "نص الزر في الودجت الذي يتيح للزائر مغادرة الموضوع الحالي والسؤال عن شيء آخر. اتركه فارغًا لاستخدام النص الافتراضي بلغة الزائر."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "تأجيل المكالمات الفائتة تلقائياً لمدة X دقيقة",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "تأجيل المكالمات الفائتة تلقائياً لعدد الدقائق المحدد. اترك الحقل فارغاً أو 0 للتعطيل."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "حل المكالمة الفائتة بعد X محاولات اتصال فاشلة",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "بعد معاودة الاتصال بالمكالمة الفائتة X مرات دون أن يرد العميل، يتم حلها تلقائياً وإضافة ملاحظة خاصة. اترك الحقل فارغاً أو 0 للتعطيل."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "اقتراحات الأسئلة",
        "SUB_TEXT": "قم بتهيئة أسئلة محددة مسبقاً يمكن للعملاء استخدامها للتفاعل مع وكلائك.",
        "QUESTIONS_LABEL": "الأسئلة",
        "ADD_QUESTION": "إضافة سؤال",
        "REMOVE": "إزالة",
        "QUESTION_TEXT": "النص المعروض في الفقاعة.",
        "QUESTION_TEXT_PLACEHOLDER": "مطلوب",
        "QUESTION_PAYLOAD": "النص الذي يُرسل عند النقر.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "اختياري",
        "NO_BOT_MESSAGE": "لتوليد اقتراحات ذكاء اصطناعي إضافية، يرجى ربط روبوت.",
        "BOT_CONNECTED_MESSAGE": "يمكن تفعيل اقتراحات الأسئلة بالذكاء الاصطناعي من الروبوت في",
        "BOT_SETTINGS_LINK": "إعداداته"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "عناوين بريد بديلة",
        "SUB_TEXT": "عناوين إضافية يجب أن يعاملها هذا البريد الوارد كعناوينه الخاصة عند استقبال البريد المُحوَّل.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "إضافة",
        "REMOVE": "إزالة",
        "EMPTY": "لا توجد عناوين بريد بديلة مُهيَّأة.",
        "HELP_TEXT": "عند وصول رسالة بريد إلكتروني إلى أحد هذه العناوين كمستلِم، سيتم إرسال الردود بنفس العنوان كمُرسِل. تأكد من أن خادم SMTP الصادر لديك يسمح بالإرسال من هذه العناوين.",
        "SIGNATURE_LABEL": "التوقيع",
        "PRIMARY_SIGNATURE": "الأساسي (افتراضي)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "توقيعات إضافية",
        "SUB_TEXT": "عرّف توقيعات إضافية هنا، ثم عيّنها للعناوين البديلة أدناه.",
        "OPTION": "التوقيع {number}",
        "ADD": "إضافة توقيع",
        "REMOVE": "إزالة",
        "HELP_TEXT": "عند إرسال رد من عنوان بريد بديل، يُستخدم التوقيع المخصص له بدلاً من توقيع صندوق الوارد. العناوين البديلة التي تُترك على «الأساسي (افتراضي)» تعود إلى توقيع صندوق الوارد."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "حذف",
      "AVATAR_DELETE_BUTTON_TEXT": "حذف الصورة الرمزية",
      "DELETE_REQUESTED_TOOLTIP": "تم تعليم صندوق الوارد هذا للحذف",
      "RESTORE_BUTTON_TEXT": "استعادة",
      "CONFIRM": {
        "TITLE": "تأكيد الحذف",
        "MESSAGE": "هل أنت متأكد من الحذف ",
        "PLACE_HOLDER": "الرجاء كتابة {inboxName} للتأكيد",
        "YES": "نعم، احذف ",
        "NO": "لا، احتفظ "
      },
      "API": {
        "SUCCESS_MESSAGE": "تم حذف قناة التواصل بنجاح",
        "MARKED_FOR_DELETION_MESSAGE": "تم تعليم صندوق الوارد للحذف",
        "RESTORE_SUCCESS_MESSAGE": "تمت استعادة صندوق الوارد بنجاح",
        "ERROR_MESSAGE": "تعذر حذف قناة التواصل. الرجاء المحاولة مرة أخرى لاحقاً.",
        "RESTORE_ERROR_MESSAGE": "تعذرت استعادة صندوق الوارد. يرجى المحاولة مرة أخرى لاحقاً.",
        "AVATAR_SUCCESS_MESSAGE": "تم حذف الصورة الرمزية لصندوق الوارد بنجاح",
        "AVATAR_ERROR_MESSAGE": "لا يمكن حذف الصورة الرمزية لصندوق الوارد. الرجاء المحاولة مرة أخرى لاحقاً."
      }
    },
    "TABS": {
      "SETTINGS": "الإعدادات",
      "COLLABORATORS": "المتعاونون",
      "AUTOMATIC_PRIORITY": "الأولوية التلقائية",
      "AUTOMATIC_LABELING": "الوسم التلقائي",
      "CONFIGURATION": "الإعدادات",
      "CAMPAIGN": "الحملات",
      "PRE_CHAT_FORM": "نموذج ما قبل الدردشة",
      "BUSINESS_HOURS": "ساعات العمل",
      "WIDGET_BUILDER": "منشئ اللايف شات",
      "BOT_CONFIGURATION": "اعدادات البوت",
      "SLA": "SLA"
    },
    "SETTINGS": "الإعدادات",
    "FEATURES": {
      "LABEL": "الخصائص",
      "DISPLAY_FILE_PICKER": "عرض أداة انتقاء الملفات في الـ widget",
      "DISPLAY_EMOJI_PICKER": "عرض منتقي الرموز التعبيرية على الـ widget",
      "ALLOW_END_CONVERSATION": "السماح للمستخدمين بإنهاء المحادثة من عنصر واجهة المستخدم",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "إظهار زر 'بدء محادثة جديدة' في رأس الأداة",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Hide input field when start new conversation button is shown",
      "SHOW_HANDOFF_BUTTON": "إظهار زر 'التحويل إلى موظف الدعم' في رأس الأداة",
      "AUTO_CLOSE_OLD": "وضع علامة على جميع المكالمات السابقة من نفس الرقم كمحلولة بعد حل إحداها",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "تعيين المكالمات الفائتة تلقائياً عند إجراء مكالمة صادرة",
      "USE_INBOX_AVATAR_FOR_BOT": "Use inbox name and avatar for the bot",
      "ALLOW_OFFLINE_REPLY": "السماح للوكلاء بإرسال رسائل عندما تكون جهة الاتصال غير متصلة ولا تتوفر خدمة استمرار البريد الإلكتروني"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "كود \"الماسنجر\"",
      "MESSENGER_SUB_HEAD": "ضع هذا الكود داخل وسم الـ body في موقعك",
      "INBOX_AGENTS": "وكيل الدعم",
      "INBOX_TEAMS": "الفرق",
      "INBOX_COOPERATORS": "المتعاونون",
      "SELECT_PLACEHOLDER": "اختر",
      "AGENTS_OR_TEAMS_INFO": "يمكنك تعيين إما وكلاء أو فرق - وليس كليهما في آن واحد.",
      "INBOX_AGENTS_SUB_TEXT": "إضافة أو إزالة وكلاء من صندوق الوارد هذا",
      "AGENT_ASSIGNMENT": "تعيين المحادثة",
      "AGENT_ASSIGNMENT_SUB_TEXT": "تحديث إعدادات إسناد المحادثات",
      "UPDATE": "تحديث",
      "ENABLE_EMAIL_COLLECT_BOX": "تفعيل صندوق جمع البريد الإلكتروني",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "تمكين أو تعطيل مربع جمع البريد الإلكتروني في محادثة جديدة",
      "AUTO_ASSIGNMENT": "تفعيل الإسناد التلقائي",
      "ENABLE_CSAT": "تمكين تقييم خدمة العملاء",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "تفعيل تقييم خدمة العملاء (CSAT) على كل رسالة",
      "SENDER_NAME_SECTION": "تمكين اسم الوكيل في البريد الإلكتروني",
      "ENABLE_CSAT_SUB_TEXT": "تمكين/تعطيل تقييم خدمة العملاء بعد إنتهاء المحادثة",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "تفعيل/تعطيل خيار استبيان تقييم خدمة العملاء لكل رسالة يرسلها الوكلاء",
      "SENDER_NAME_SECTION_TEXT": "تمكين/تعطيل إظهار اسم الوكيل في البريد الإلكتروني، إذا تم تعطيله فسيظهر اسم المنشأة",
      "ENABLE_CONTINUITY_VIA_EMAIL": "تمكين استمرارية المحادثة عبر البريد الإلكتروني",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "المحادثات ستستمر عبر البريد الإلكتروني إذا كان عنوان البريد الإلكتروني لجهة الاتصال متاحاً.",
      "RESPOND_FROM_EMAIL": "الرد من البريد الإلكتروني",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "تُرسل رسائل البريد الإلكتروني إلى العميل — الردود ونصوص المحادثات على حد سواء — باستخدام إعدادات SMTP لصندوق الوارد المحدد، من العنوان المحدد (عنوان صندوق الوارد نفسه أو أحد أسمائه المستعارة)، وتصل ردود العميل عبر عنوان IMAP الخاص به.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "تُرسل نصوص المحادثات باستخدام إعدادات SMTP لصندوق الوارد المحدد، من العنوان المحدد (عنوان صندوق الوارد نفسه أو أحد أسمائه المستعارة)، وتصل الردود عبر عنوان IMAP الخاص به.",
      "SHOW_WELCOME_SCREEN": "إظهار شاشة الترحيب",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "إظهار شاشة الترحيب عند فتح الأداة. في حال التعطيل، ستنتقل الأداة مباشرة إلى عرض المحادثة.",
      "AUTO_CLOSE_PENDING": "حل محادثات الذكاء الاصطناعي تلقائياً بعد (ساعات)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "حل محادثات الذكاء الاصطناعي تلقائياً بعد X ساعة من عدم النشاط.",
      "LOCK_TO_SINGLE_CONVERSATION": "قفل إلى محادثة واحدة",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "تمكين أو تعطيل محادثات متعددة لنفس جهة الاتصال في هذا البريد الوارد",
      "INBOX_UPDATE_TITLE": "إعدادات قناة التواصل",
      "INBOX_UPDATE_SUB_TEXT": "تحديث إعدادات قناة التواصل",
      "AUTO_ASSIGNMENT_SUB_TEXT": "تمكين أو تعطيل الإسناد التلقائي للمحادثات الجديدة إلى الموظفين المضافين إلى قناة التواصل هذه.",
      "HMAC_VERIFICATION": "التحقق من هوية المستخدم",
      "HMAC_DESCRIPTION": "من أجل التحقق من هوية المستخدم، يمكنك تمرير 'IDer_hash` لكل مستخدم. يمكنك إنشاء تجزئة HMAC sha256 باستخدام \"المعرف\" مع المفتاح المعروض هنا.",
      "HMAC_ROTATE": {
        "BUTTON": "تدوير المفتاح",
        "TITLE": "هل تريد تدوير المفتاح السري؟",
        "WARNING": "يُلغى المفتاح الحالي فور تدويره.",
        "WARNING_DETAIL": "لا توجد فترة تداخل، ولا يمكن استعادته.",
        "IMPACT": "يجب أن توقّع خوادمك المستخدمين بالمفتاح الجديد. أي شخص لا يزال موقّعًا بالمفتاح القديم يفشل في التحقق. إذا كان التحقق من هوية المستخدم إلزاميًا، فلن يتمكن من بدء محادثة.",
        "CONFIRM": "تدوير المفتاح",
        "CANCEL": "إلغاء",
        "SUCCESS": "تم تدوير المفتاح السري بنجاح",
        "ERROR": "تعذر تدوير المفتاح السري، الرجاء المحاولة مرة أخرى"
      },
      "HMAC_LINK_TO_DOCS": "You can read more here.",
      "HMAC_MANDATORY_VERIFICATION": "فرض التحقق من هوية المستخدم",
      "HMAC_MANDATORY_DESCRIPTION": "في حالة التمكين، سيتم رفض الطلبات المفقودة 'IDer_hash'.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "فرض محادثة جديدة عند كل تحميل للودجت",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "في حال التفعيل، يؤدي فتح الودجت في علامة تبويب أو نافذة جديدة إلى بدء محادثة جديدة.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "نسيان جهة الاتصال عند بدء محادثة جديدة",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "في حال التعطيل، تحتفظ المحادثة الجديدة التي تبدأ من الودجت بجهة الاتصال السابقة.",
      "INBOX_IDENTIFIER": "معرف صندوق الوارد",
      "INBOX_IDENTIFIER_SUB_TEXT": "استخدم رمز 'inbox_identifier' المعروض هنا للمصادقة على عملاء API الخاص بك.",
      "FORWARD_EMAIL_TITLE": "إعادة التوجيه إلى البريد الإلكتروني",
      "FORWARD_EMAIL_SUB_TEXT": "بدء إعادة توجيه رسائل البريد الإلكتروني الخاصة بك إلى عنوان البريد الإلكتروني التالي.",
      "EMAIL_FETCHING_ENABLED_TITLE": "مزامنة البريد الإلكتروني",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "تفعيل المزامنة التلقائية وتنزيل رسائل البريد الإلكتروني الواردة من صندوق الوارد هذا",
      "CUSTOM_EMAIL_ENABLED_TITLE": "نطاق بريد إلكتروني مخصص",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "تفعيل استخدام نطاق بريد إلكتروني مخصص لرسائل البريد الصادرة",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "يمكنك قراءة المزيد هنا.",
      "FACEBOOK_COMMENTS_TITLE": "تعليقات Facebook",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "السماح بالرسائل بعد حل المحادثة",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "السماح للمستخدمين النهائيين بإرسال رسائل حتى بعد تسوية المحادثة.",
      "WIDGET_STATUS_LABEL": "حالة الأداة",
      "WIDGET_STATUS_ENABLED": "مفعّلة",
      "WIDGET_STATUS_BUSINESS_HOURS": "مفعّلة خلال ساعات العمل",
      "WIDGET_STATUS_DISABLED": "معطّلة",
      "WIDGET_STATUS_HELP_TEXT": "تحكم في وقت ظهور الأداة للزوار على موقعك الإلكتروني",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Update Pre Chat Form Settings",
      "EXPLICIT_CSAT_LOCALE": "لغة استبيان تقييم خدمة العملاء والبريد الإلكتروني",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "اختر لغة جميع رسائل البريد الإلكتروني للعملاء، بما في ذلك استبيانات تقييم خدمة العملاء ونصوص المحادثات وإشعارات البريد الإلكتروني",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "وراثة من الحساب",
      "WHATSAPP_CONNECTION": {
        "TITLE": "اتصال واتساب",
        "SUBTITLE": "طريقة اتصال صندوق الوارد هذا بواتساب.",
        "PROVIDER": "المزوّد",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "متصل عبر التسجيل المضمّن من Meta",
        "STATUS": "الحالة",
        "CONNECTED": "متصل",
        "RECONNECT_HINT": "انقر على إعادة الاتصال في الإشعار أعلاه.",
        "PHONE_NUMBER": "رقم الهاتف",
        "BUSINESS_ACCOUNT": "معرّف حساب واتساب للأعمال",
        "OPEN_MANAGER": "فتح في WhatsApp Manager",
        "PHONE_NUMBER_ID": "معرّف رقم الهاتف",
        "TEMPLATES": "قوالب الرسائل",
        "TEMPLATES_COUNT": "{approved} من {total} معتمدة",
        "TEMPLATES_SYNCED": "آخر مزامنة {date}",
        "TEMPLATES_NOT_SYNCED": "لم تتم المزامنة بعد",
        "MANAGE_TEMPLATES": "إدارة القوالب"
      }
    },
    "HELP_CENTER": {
      "LABEL": "مركز المساعدة",
      "PLACEHOLDER": "Select Help Center",
      "SELECT_PLACEHOLDER": "Select Help Center",
      "REMOVE": "Remove Help Center",
      "SUB_TEXT": "Attach a Help Center with the inbox"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "حد الإسناد التلقائي",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "الرجاء إدخال قيمة أكبر من 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "تحديد الحد الأقصى لعدد المحادثات من علبة الوارد هذه التي يمكن تعيينها تلقائياً إلى وكيل"
    },
    "SLA": {
      "TITLE": "سياسات مستوى الخدمة (SLA)",
      "SUB_TEXT": "قم بتهيئة أوقات الرد والحل لاتفاقية مستوى الخدمة لكل مستوى أولوية للمحادثة.",
      "LOADING": "جارٍ تحميل سياسات مستوى الخدمة...",
      "FIELDS": {
        "ACTIVE": "نشطة",
        "TICKET_PRIORITY": "أولوية التذكرة",
        "FIRST_RESPONSE_TIME": "وقت الرد الأول",
        "EVERY_RESPONSE_TIME": "وقت كل رد",
        "RESOLUTION_TIME": "وقت الحل",
        "PLACEHOLDER": "مثال: 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "تم تحديث سياسات مستوى الخدمة بنجاح.",
        "ERROR_MESSAGE": "تعذر تحديث سياسات مستوى الخدمة. يرجى المحاولة مرة أخرى."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "الأولوية التلقائية",
      "SUB_TEXT": "قم بتهيئة تعيين الأولوية التلقائي استناداً إلى محتوى المحادثة.",
      "BILLING_DISCLAIMER": {
        "TITLE": "إشعار الفوترة",
        "MESSAGE": "سيترتب على كل عملية تقييم أولوية رسوم. يرجى مراجعة تفاصيل خطتك لمعرفة معلومات التسعير."
      },
      "MODE": {
        "OFF": "إيقاف",
        "ALL_MESSAGES": "مفعّل لجميع الرسائل الواردة",
        "FIRST_MESSAGE": "مفعّل للرسالة الواردة الأولى فقط"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "تهيئة مستويات الأولوية",
        "SUB_TEXT": "قم بتهيئة مستويات الأولوية التي يجب تفعيلها وأوصافها. قدّم معايير واضحة ليحدد الذكاء الاصطناعي متى يجب تعيين هذه الأولوية."
      },
      "DESCRIPTION_LABEL": "الوصف",
      "DESCRIPTION_PLACEHOLDER": "صف المحادثات التي يجب تعيين أولوية {priority} لها",
      "SET_AS_DEFAULT": "تعيين كأولوية افتراضية",
      "MULTIPLE_DEFAULTS_WARNING": "يجب تعيين مستوى أولوية واحد فقط كافتراضي. يرجى إلغاء تحديد الافتراضيات الأخرى."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "الوسم التلقائي",
      "SUB_TEXT": "قم بتهيئة تعيين الوسوم التلقائي استناداً إلى محتوى المحادثة.",
      "BILLING_DISCLAIMER": {
        "TITLE": "إشعار الفوترة",
        "MESSAGE": "سيترتب على كل عملية تقييم وسم رسوم. يرجى مراجعة تفاصيل خطتك لمعرفة معلومات التسعير."
      },
      "MODE": {
        "OFF": "إيقاف",
        "CONVERSATION_OPEN": "عند فتح المحادثة",
        "CONVERSATION_CLOSE": "عند إغلاق المحادثة",
        "ALL_MESSAGES": "عند كل رسالة - بغض النظر عن الحالة",
        "FIRST_MESSAGE": "عند الرسالة الأولى - بغض النظر عن الحالة"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "تهيئة الوسوم",
        "SUB_TEXT": "قم بتهيئة الوسوم التي يجب أن تكون متاحة للتعيين التلقائي وأوصافها. قدّم معايير واضحة ليحدد الذكاء الاصطناعي متى يجب تطبيق هذا الوسم."
      },
      "DESCRIPTION_LABEL": "الوصف",
      "DESCRIPTION_PLACEHOLDER": "صف المحادثات التي يجب وسمها بـ {label}. إذا تركت هذا فارغاً، سيُستخدم وصف الوسم.",
      "NO_LABELS_MESSAGE": "لم يتم العثور على وسوم. أنشئ وسوماً أولاً لتفعيل الوسم التلقائي.",
      "CREATE_LABELS_LINK": "إنشاء وسوم"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "إعادة التصريح",
      "SUBTITLE": "انتهت صلاحية اتصال الفيسبوك الخاص بك، يرجى إعادة الاتصال بصفحة الفيسبوك الخاصة بك لمواصلة الخدمات",
      "MESSAGE_SUCCESS": "تمت إعادة الاتصال بنجاح",
      "MESSAGE_ERROR": "حدث خطأ، الرجاء المحاولة مرة أخرى"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "نماذج ما قبل الدردشة تمكنك من التقاط معلومات المستخدم قبل بدء المحادثة معك.",
      "SET_FIELDS": "حقول نموذج الدردشة السابقة",
      "SET_FIELDS_HEADER": {
        "FIELDS": "الحقول",
        "LABEL": "الوسم",
        "PLACE_HOLDER": "المحتوى",
        "KEY": "المفتاح",
        "TYPE": "النوع",
        "REQUIRED": "مطلوب"
      },
      "ENABLE": {
        "LABEL": "تمكين نموذج الدردشة السابقة",
        "OPTIONS": {
          "ENABLED": "نعم",
          "DISABLED": "لا"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "رسالة ما قبل المحادثة",
        "PLACEHOLDER": "ستكون هذه الرسالة مرئية للمستخدمين مع النموذج"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "يجب على الزوار تقديم اسمهم وعنوان بريدهم الإلكتروني قبل بدء المحادثة"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "قم بتعيين توافرك",
      "SUBTITLE": "تعيين توافرك على أداة الدردشة المباشرة الخاصة بك",
      "WEEKLY_TITLE": "تعيين ساعات العمل الأسبوعية الخاصة بك",
      "TIMEZONE_LABEL": "اختر المنطقة الزمنية",
      "UPDATE": "تحديث إعدادات ساعات العمل",
      "TOGGLE_AVAILABILITY": "تمكين توافر العمل لهذا البريد الوارد",
      "UNAVAILABLE_MESSAGE_LABEL": "رسالة غير متاح للزائرين",
      "TOGGLE_HELP": "تمكين توفر العمل سيظهر الساعات المتاحة على أداة الدردشة المباشرة حتى لو كان جميع الوكلاء غير متصلين بالإنترنت. خارج الساعات المتاحة يمكن تحذير الزوار برسالة ونموذج ما قبل الدردشة.",
      "DAY": {
        "ENABLE": "تمكين التوفر لهذا اليوم",
        "UNAVAILABLE": "غير متوفر",
        "HOURS": "ساعات",
        "VALIDATION_ERROR": "يجب أن يكون وقت البدء قبل وقت الإغلاق.",
        "CHOOSE": "اختر"
      },
      "ALL_DAY": "جميع الأيام",
      "SAVE_TO_ALL": "الحفظ في جميع صناديق الوارد",
      "SAVE_TO_ALL_TITLE": "نسخ ساعات العمل",
      "SAVE_TO_ALL_CONFIRM": "سيتم نسخ إعدادات هذا النموذج (مفتاح التوافر، رسالة خارج أوقات العمل، المنطقة الزمنية وساعات العمل) إلى جميع صناديق الوارد الأخرى باستثناء صناديق البريد الإلكتروني والهاتف. هل أنت متأكد أنك تريد المتابعة؟",
      "SAVE_TO_ALL_CANCEL": "إلغاء",
      "SAVE_TO_ALL_YES": "نعم، انسخ إلى الجميع",
      "SAVE_TO_ALL_SUCCESS": "تم نسخ ساعات العمل إلى جميع صناديق الوارد الأخرى بنجاح",
      "SAVE_TO_ALL_ERROR": "فشل نسخ ساعات العمل إلى صناديق الوارد الأخرى"
    },
    "PHONE": {
      "TITLE": "إعدادات الهاتف",
      "SUBTITLE": "قم بتهيئة المكالمات التي ستظهر ضمن صندوق الوارد هذا.",
      "UPDATE": "حفظ الإعدادات",
      "EDIT": {
        "SUCCESS_MESSAGE": "تم تحديث إعدادات الهاتف"
      },
      "PHONE_NUMBERS": {
        "LABEL": "أرقام الهاتف",
        "PLACEHOLDER": "+145123908635"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "تعيين تفاصيل IMAP الخاصة بك",
      "NOTE_TEXT": "لتمكين SMTP ، الرجاء تكوين IMAP.",
      "UPDATE": "تحديث الإعدادات",
      "TOGGLE_AVAILABILITY": "تمكين تكوين IMAP لهذا البريد الوارد",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "تم تحديث إعدادات IMAP بنجاح",
        "ERROR_MESSAGE": "غير قادر على تحديث إعدادات IMAP"
      },
      "ADDRESS": {
        "LABEL": "العنوان",
        "PLACE_HOLDER": "العنوان (على سبيل المثال: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "المنفذ",
        "PLACE_HOLDER": "المنفذ"
      },
      "LOGIN": {
        "LABEL": "تسجيل الدخول",
        "PLACE_HOLDER": "تسجيل الدخول"
      },
      "PASSWORD": {
        "LABEL": "كلمة المرور",
        "PLACE_HOLDER": "كلمة المرور"
      },
      "ENABLE_SSL": "تمكين SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reauthorize your MICROSOFT account"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "تعيين تفاصيل IMAP الخاصة بك",
      "UPDATE": "تحديث إعدادات SMTP",
      "TOGGLE_AVAILABILITY": "تمكين تكوين IMAP لهذا البريد الوارد",
      "TOGGLE_HELP": "تمكين SMTP سيساعد المستخدم على إرسال البريد الإلكتروني",
      "EDIT": {
        "SUCCESS_MESSAGE": "تم تحديث إعدادات SMTP بنجاح",
        "ERROR_MESSAGE": "غير قادر على تحديث إعدادات SMTP"
      },
      "ADDRESS": {
        "LABEL": "العنوان",
        "PLACE_HOLDER": "العنوان (على سبيل المثال: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "المنفذ",
        "PLACE_HOLDER": "المنفذ"
      },
      "LOGIN": {
        "LABEL": "تسجيل الدخول",
        "PLACE_HOLDER": "تسجيل الدخول"
      },
      "PASSWORD": {
        "LABEL": "كلمة المرور",
        "PLACE_HOLDER": "كلمة المرور"
      },
      "DOMAIN": {
        "LABEL": "النطاق",
        "PLACE_HOLDER": "الدومين"
      },
      "ENCRYPTION": "التشفير",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "فتح وضع التحقق من SSL",
      "AUTH_MECHANISM": "المصادقة"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "قابلية وصول البريد (DNS)",
      "SUB_TITLE": "نفحص سجلات SPF وDKIM وDMARC وMX للنطاق {domain} كل يوم عمل. عندما يتسبب أمر ما في رفض الخوادم المستقبِلة لردودكم أو نقلها إلى البريد غير الهام، يصل المسؤولين بريد إلكتروني يتضمن طريقة الإصلاح.",
      "RUN": "تشغيل الفحص",
      "RUN_SUCCESS": "انتهى فحص DNS",
      "RUN_ERROR": "تعذّر تشغيل فحص DNS، يرجى المحاولة مرة أخرى",
      "NOT_CHECKED": "لم يتم الفحص بعد.",
      "CHECKED_AT": "آخر فحص: {time}.",
      "DNS_UNAVAILABLE": "لم يصل الفحص الأخير أي رد من خوادم أسماء النطاق. النتيجة أدناه من الفحص السابق.",
      "SENDER": {
        "SMTP": "تُرسل الردود عبر {host}.",
        "PLATFORM": "تُرسل الردود عبر خوادم البريد لدينا."
      },
      "STATUS": {
        "OK": "جميع السجلات سليمة",
        "WARNING": "بعض السجلات يمكن تحسينها",
        "ERROR": "قد لا تصل الردود إلى المستلمين",
        "UNKNOWN": "غير معروف"
      },
      "SEVERITY": {
        "ERROR": "مشكلة",
        "WARNING": "تحذير"
      },
      "FIX": "يمكن إصلاح ذلك بسجل DNS التالي:",
      "RECORD_TYPE": "النوع",
      "RECORD_HOST": "الاسم",
      "RECORD_VALUE": "القيمة",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "سجل SPF غير موجود",
          "DESCRIPTION": "لا يحدد النطاق الخوادم المسموح لها بإرسال بريده. لذلك تعتبر كثير من خوادم البريد ردودكم رسائل غير مرغوب فيها. أضيفوا سجل SPF يسمح بـ {sender}."
        },
        "spf_multiple": {
          "TITLE": "يوجد في النطاق {count} من سجلات SPF",
          "DESCRIPTION": "يجب أن يكون للنطاق سجل SPF واحد فقط. عند وجود أكثر من سجل، تتجاهل الخوادم المستقبِلة SPF وغالباً ترفض الرسائل. ادمجوها في سجل واحد."
        },
        "spf_not_authorized": {
          "TITLE": "SPF لا يسمح بالخادم الذي يرسل ردودكم",
          "DESCRIPTION": "تُرسل ردودكم عبر {sender}، لكن سجل SPF للنطاق لا يتضمنه. السجل الحالي: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "سجل SPF يحتاج إلى عدد كبير جداً من عمليات بحث DNS",
          "DESCRIPTION": "تتوقف الخوادم المستقبِلة عن فحص SPF بعد {limit} من عمليات بحث DNS، لكن الوصول إلى {sender}، الذي يرسل ردودكم، لا يتم إلا بعد {lookups}. لذلك تفشل ردودكم في فحص SPF. انقلوا {sender} إلى بداية السجل واحذفوا عناصر include التي لم يعد النطاق يستخدمها."
        },
        "spf_lookups_others": {
          "TITLE": "بعض الجهات المرسلة في سجل SPF تتجاوز حد عمليات البحث",
          "DESCRIPTION": "يحتاج سجل SPF إلى {lookups} من عمليات بحث DNS، بينما تتوقف الخوادم المستقبِلة بعد {limit}. تتم مطابقة ردودكم في الوقت المناسب وتنجح، لكن الرسائل المرسلة من هذه الجهات تفشل في فحص SPF: {senders}. احذفوا عناصر include التي لم يعد النطاق يستخدمها."
        },
        "spf_malformed": {
          "TITLE": "سجل SPF معطوب",
          "DESCRIPTION": "لا تستطيع الخوادم المستقبِلة قراءة سجل SPF الخاص بالنطاق، لذلك لا يحمي هذا السجل ردودكم. المشكلة في: {terms}. استبدلوا السجل بالنسخة المصححة."
        },
        "dkim_missing": {
          "TITLE": "توقيع DKIM غير مُعدّ",
          "DESCRIPTION": "لم نعثر على مفتاح DKIM في {selectors}. بدونه لا تكون ردودكم موقّعة وتزداد احتمالية وصولها إلى البريد غير الهام. فعّلوا توقيع DKIM للنطاق لدى مزوّد البريد الإلكتروني."
        },
        "dmarc_missing": {
          "TITLE": "سجل DMARC غير موجود",
          "DESCRIPTION": "تتوقع مزوّدات البريد الكبرى مثل Gmail وMicrosoft وجود سجل DMARC. بدونه تزداد احتمالية وصول ردودكم إلى البريد غير الهام."
        },
        "dmarc_fails": {
          "TITLE": "DMARC يطلب من المستقبِلين رفض ردودكم",
          "DESCRIPTION": "سياسة DMARC للنطاق هي “{policy}” ولا تجتاز ردودكم فحص SPF ولا DKIM، لذلك يرفضها المستقبِلون أو ينقلونها إلى البريد غير الهام. أصلحوا SPF وDKIM المذكورين أعلاه."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC يحظر الردود المرسلة عبر خوادم البريد لدينا",
          "DESCRIPTION": "يرسل هذا الصندوق الردود عبر خوادم البريد لدينا، لكن سياسة DMARC للنطاق هي “{policy}”، لذلك يرفضها المستقبِلون أو ينقلونها إلى البريد غير الهام. أعدّوا SMTP لخادم البريد الخاص بكم لهذا الصندوق."
        },
        "mx_missing": {
          "TITLE": "لا يوجد سجل MX للنطاق",
          "DESCRIPTION": "بدون سجل MX لا يستطيع أحد إرسال بريد إلى النطاق، لذلك لا يستطيع العملاء الرد على رسائلكم."
        }
      }
    },
    "NOTE": "ملاحظة: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "صورة الموقع",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "الصورة الرمزية حذفت بنجاح",
              "ERROR_MESSAGE": "حدث خطأ، الرجاء المحاولة مرة أخرى"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "اسم الموقع",
          "PLACE_HOLDER": "أدخل اسم موقع الويب الخاص بك (مثال: Acme Inc)",
          "ERROR": "الرجاء إدخال اسم موقع صالح"
        },
        "WELCOME_HEADING": {
          "LABEL": "العنوان الترحيبي",
          "PLACE_HOLDER": "مرحبا بك!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "افتتاحية الترحيب",
          "PLACE_HOLDER": "نحن نجعل من السهل عليك التواصل معنا. اسألنا أي شيء، أو قم بمشاركتنا ملاحظاتك."
        },
        "REPLY_TIME": {
          "LABEL": "وقت الرد",
          "IN_A_FEW_MINUTES": "في غضون دقائق قليلة",
          "IN_A_FEW_HOURS": "في غضون ساعات قليلة",
          "IN_A_DAY": "خلال يوم"
        },
        "WIDGET_COLOR_LABEL": "لون صندوق الدردشة",
        "WIDGET_BUBBLE_POSITION_LABEL": "موقع شعار اللايف شات",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "الحد الأقصى لارتفاع الرسائل غير المقروءة (px)",
          "PLACE_HOLDER": "بلا حد",
          "HELP_TEXT": "حدّد الحد الأقصى لارتفاع نافذة الرسائل غير المقروءة بالبكسل. اتركه فارغًا للسلوك الافتراضي (بلا حد)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "شكل عرض اللايف شات",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "تحدث الينا",
          "LABEL": "عنوان ايقونة اللايف شات",
          "PLACE_HOLDER": "تحدث الينا"
        },
        "UPDATE": {
          "BUTTON_TEXT": "تحديث إعدادات اللايف شات",
          "API": {
            "SUCCESS_MESSAGE": "تم تحديث إعدادت اللايف شات بنجاح",
            "ERROR_MESSAGE": "غير قادر على تحديث إعدادات اللايف شات"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "معاينة",
          "SCRIPT": "النص"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "يسار",
          "RIGHT": "يمين"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "عادي",
          "EXPANDED_BUBBLE": "ايقونت اللايف شات العرضية"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "افتراضي",
        "CHAT": "محادثة"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "عادة نقوم بالرد خلال بضع دقائق",
        "IN_A_FEW_HOURS": "عادة نقوم بالرد خلال بضع ساعات",
        "IN_A_DAY": "عادة نقوم بالرد خلال يوم واحد"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "ابدأ المحادثة",
        "CHAT_INPUT_PLACEHOLDER": "أكتب رسالتك"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "متواجدون لخدمتك",
          "OFFLINE": "نحن بعيدون في الوقت الحالي"
        },
        "USER_MESSAGE": "مرحبا",
        "AGENT_MESSAGE": "مرحبا"
      },
      "BRANDING_TEXT": "مدعوم بواسطة JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Other Providers"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "الموقع الإلكتروني",
      "TWITTER_PROFILE": "تويتر",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "واتساب",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "البريد الإلكتروني",
      "TELEGRAM": "تيليجرام",
      "LINE": "Line",
      "API": "قناة API",
      "PHONE": "هاتف SIP",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
